import { rangeClickExtension } from "./range-interactions.js";

export { findClickedRangeTarget, rangeClickExtension } from "./range-interactions.js";
export { reviewTrackChangesTheme } from "./range-theme.js";

export function reviewThreadClickExtension(onSelectReviewThread) {
    if (!onSelectReviewThread) {
        return [];
    }

    return rangeClickExtension((rangeTarget) => {
        if (rangeTarget?.kind !== "comment") {
            return false;
        }

        onSelectReviewThread(rangeTarget.id, { source: "editor", pos: rangeTarget.pos });
        return true;
    });
}
